<template>
    <div class="d-flex flex-row align-items-center position-relative" @click="$emit('click')">
        <b-icon
            v-if="showRemove"
			icon="x"
			@click.stop="$emit('remove')"
			class="position-absolute"
			style="cursor: pointer; top: 1rem; right: 1rem;"
		/>
		<div>
            <p class="bold mt-0 mb-0">
                <strong>
                	<template v-if="this.session.competencytest">
                    	{{ this.session.competencytest.code }}:
                    	{{ this.session.competencytest.title }}
                	</template>
                	<template v-else>
                    	{{ session.Code }}:
                    	{{ session.Name }}
                	</template>
                </strong>
            </p>
            <p class="small mt-0 mb-0">
                <b-icon icon="person" class="mr-1" />
                {{ isTeacher ? student_displayname : teacher_displayname }}
            </p>
            <p class="small mt-0 mb-0">
                <b-icon icon="clock" class="mr-1" />
                {{
                    isNaN(session.DateMarked)
                    ? `${$datetime.getLocaleStringFromISODate(session.DateMarked)} ${$datetime.isoDateTimeToTime(session.DateMarked)}`
                    : $datetime.getLocaleStringFromTimeStamp(session.DateMarked)
                }}
            </p>
        </div>

        <div class="mt-3">
            <LabelIndicator v-if="session.HasPassed === 1" type="success">{{ getDichotomy('true') }}</LabelIndicator>
            <LabelIndicator v-if="session.HasPassed === 0" type="danger">{{ getDichotomy('false') }}</LabelIndicator>
        </div>
	</div>
</template>

<script>
import LabelIndicator from "src/components/LabelIndicator";

export default {
    components: {
        LabelIndicator
    },
    props: {
        session: Object,
        showRemove: Boolean,
    },
    mounted() {
        this.$users.getDisplayName.call(this, this.session.teacher_id).then(name => {
            this.teacher_displayname = name
        })
        this.$users.getDisplayName.call(this, this.session.student_id).then(name => {
            this.student_displayname = name
        })
    },
    data() {
        return {
            teacher_displayname: '',
            student_displayname: '',
        }
    },
    methods: {
        getDichotomy(type){
			if(this.$config.getValue('dichotomies') && this.session.dichotomy_id in this.$config.getValue('dichotomies')){
				return this.$config.getValue('dichotomies')[this.session.dichotomy_id][type]
			}
			if(type == 'true'){
				return this.$t('pass');
			}
			if(type == 'false'){
				return this.$t('fail');
			}
		}
    },
    computed: {
        isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
    }
}
</script>
